import Vue from 'vue'
const App = () => import(/* webpackPrefetch: true */ './App.vue')
import router from './router'
import store from './store'
import { config } from './config.js';
import debounce from 'lodash/debounce';
import isEmpty from 'lodash/isEmpty';
import filters from './filters.js';
import Multiselect from 'vue-multiselect';
import VueGoogleCharts from 'vue-google-charts';
import LoaderComponent from '@/components/preloader/LoaderComponent';
import ContentOrLoading from '@/components/backend/components/ContentOrLoading';
import FormInput from "@/components/common/FormInput";
import Button from "@/components/common/Button";
import vmodal from 'vue-js-modal';
import "./vee-validate";
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import VueCarousel from 'vue-carousel';
import PerfectScrollbar from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
import VueFormulate from '@braid/vue-formulate';
import { es } from '@braid/vue-formulate-i18n';
import panZoom from 'vue-panzoom';
import VueGtm from "vue-gtm";
import VueCookies from 'vue-cookies';
import 'leaflet/dist/leaflet.css';
import i18n from "./i18n";
import VueFab from 'vue-float-action-button';
import VueLazyload from 'vue-lazyload'
import VueYouTubeEmbed from 'vue-youtube-embed'
import VueScrollTo  from'vue-scrollto';
import VueHead from 'vue-head';
import VueEcho from 'vue-echo-laravel';
import VCalendar from 'v-calendar';
import * as Sentry from "@sentry/vue";
import CKEditor from '@ckeditor/ckeditor5-vue2';
import Pusher from 'pusher-js';
import { loadConfig } from './configLoader.js';

Vue.use( CKEditor );
  
Vue.use(VueEcho, {
    broadcaster: 'pusher',
    key: process.env.VUE_APP_PUSHER_KEY,
    wsHost: 'socket.compralaentrada.com',
    wsPort: '443',
    wssPort:'443',
    forceTLS: false,
    encrypted: true,
    disableStats: true,
    enabledTransports: ['ws', 'wss'],
    cluster: ''
});

Vue.use(VueYouTubeEmbed)
Vue.use(VueLazyload)
Vue.use(VueFab);
Vue.use(panZoom);
Vue.use(PerfectScrollbar);
Vue.use(VueCarousel);
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueScrollTo, {
    offset: -100,
})
Vue.component('datetime', Datetime);
for(let name in filters) {
    Vue.filter(name, filters[name]);
}
Vue.use(VueToast);
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
Vue.use(VueGoogleCharts);
Vue.component('multiselect', Multiselect);
Vue.component('LoaderComponent', LoaderComponent);
Vue.component('ContentOrLoading', ContentOrLoading);
Vue.component("FormInput", FormInput);
Vue.component("Button", Button);
Vue.use(vmodal);
Vue.use(VueHead);
Vue.use(debounce);
Vue.use(isEmpty);
Vue.use(VueCookies);
Vue.use(VueFormulate, {
    plugins: [ es ],
    locale: 'es',
    locales: {
        es: {
            required({ name }) {
                return `Este campo es obligatorio`
            },
            confirm({ name }) {
                return `No coincide`
            }
        }
    }
});
Vue.use(VCalendar, {
    componentPrefix: 'vc',
});

Vue.config.productionTip = false
Vue.prototype.config = config;

(async() => {
    const dynamicConfig = await loadConfig();

    if (dynamicConfig.gtm_id) {
        Vue.use(VueGtm, {
            id: dynamicConfig.gtm_id,
            compatibility: false,
            enabled: true,
            debug: false,
            loadScript: true,
            vueRouter: router,
            trackOnNextTick: false
        });
        console.info(`✅ GTM inicializado: ${dynamicConfig.gtm_id}`);
    }

    Vue.prototype.$config = dynamicConfig;

    store.dispatch('LOAD_DYNAMIC_CONFIG').then(config => {
        console.log('Dynamic config cargado:', config);
    });

    new Vue({
        router,
        store,
        i18n,
        render: h => h(App)
    }).$mount('#app');
})();
